module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/image-1-71f9ee1c87d6fba9990e6aebe519855d.png";